import User from '@/models/User'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<User>(User, {
	namespaced: true,
	actions: {
		async findMe({ commit, getters }) {
			let promise
			if (getters.hasCached('inFlight-me')) {
				promise = getters.peekRecord('inFlight-me')
			} else {
				const userQuery = User.query().with(['vesselAttributes', 'users'])
				promise = userQuery.find('me')
				commit('cacheOne', { record: promise, cacheKey: 'inFlight-me' })
			}
			const user = (await promise).getData() as User
			commit('cacheOne', { record: user, cacheKey: 'me' })
		}
	}
})
